// removed by extract-text-webpack-plugin
module.exports = {"element":"theme__element___3tLM1","icon":"theme__icon___1Y1tB","label":"theme__label___1DgRX","text":"theme__text___xV8_c","fadeUp":"theme__fadeUp___1-B4E","lateFadeUp":"theme__lateFadeUp____Rl_5","lateFadeIn":"theme__lateFadeIn___8aG8D"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Element/theme.scss
// module id = 1302
// module chunks = 0